import { Component, effect, inject, model } from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideUser,
  lucidePenLine,
  lucideTrash2,
} from '@ng-icons/lucide';

import { CrudService } from '../../core/services/crud.service';
import { UserFormComponent } from '../user-form/user-form.component';

@Component({
  selector: 'app-user-list',
  imports: [NgIcon, UserFormComponent],
  viewProviders: [
    provideIcons({
      lucideUser,
      lucidePenLine,
      lucideTrash2,
    }),
  ],
  templateUrl: './user-list.component.html',
  styles: ``,
})
export class UserListComponent {
  private crudService = inject(CrudService);

  users: Array<any> = [];
  existingUser: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getUsers();
      }
    });
  }

  openModal() {
    this.existingUser = null;
    this.showModal.set(true);
  }

  getUsers() {
    this.crudService.getUsers().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.users = response.body;
        }
      },
    });
  }

  updateUser(user: any) {
    this.existingUser = user;
    this.showModal.set(true);
  }

  deleteUser(userId: string) {
    this.crudService.deleteUser(userId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          // this.getCategories();
          this.getUsers();
        }
      },
    });
  }
}
